import { NetworkInformation } from '../../services/newRelicReporter';

// Experimental. Keep cross-browser support in mind when using this.
export const getNavigatorNetworkInformation = (context: Window) =>
    (context.navigator as Window['navigator'] & { connection?: NetworkInformation }).connection;
